module.exports = __webpack_public_path__ + "static/zomer-seizoenen-236a22371430aadf8a1e491a28f23620.jpg";